const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'apiSearch',
    path: `${prefix}/help-doc/search`,
    method: 'post',
    params: {
      condition: ''
    },
    desc: '查询API文档'
  },
  {
    name: 'apiDetail',
    path: `${prefix}/help-doc/document/:id`,
    method: 'get',
    params: {
      id: ''
    },
    desc: '获取api文档详情'
  },
  {
    name: 'apiMenu',
    path: `${prefix}/help-doc/product-directories/api-doc`,
    method: 'get',
    params: {},
    desc: '获取api菜单'
  },
  {
    name: 'helpSearch',
    path: `${prefix}/help/doc/list`,
    method: 'get',
    params: {
      condition: ''
    },
    desc: '查询文档'
  },

  {
    name: 'helpMenu',
    path: `${prefix}/help/category/doc/list`,
    method: 'get',
    params: {},
    desc: '获取帮助分类'
  },
  {
    name: 'helpDetail',
    path: `${prefix}/help/get`,
    method: 'get',
    params: {
      id: null
    },
    desc: '获取帮助文档详情'
  },
  {
    name: 'helpComment',
    path: `${prefix}/help/upvote`,
    method: 'get',
    params: {
      id: null,
      type: 0
    },
    desc: '获取帮助文档详情'
  }
]
